const initialState = {
    depositConfig:null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case "SET_DEPOSIT_CONFIG_DATA":
            return {
                ...state,
                depositConfig:action.data
            }
        default:
            return state;
    }
}
